<optsol-ngx-spinner></optsol-ngx-spinner>
<optsol-ngx-top-nav [contexts]="contexts" [selectedContext]="selectedContext" [menuItems]="menu"
    (menuItemClicked)="menuItemClicked($event)" (togglerClicked)="toggleSideMenu()">
    <img brandImage [src]="'assets/images/logo.png'" class="logo"/>

    <ng-container environment>
      <span *ngIf="user && user.environmentName" class="mat-h4">{{user.environmentName}}</span>
    </ng-container>

</optsol-ngx-top-nav>
<mat-sidenav-container class="os-sidenav-container">
    <mat-sidenav [(opened)]="sideMenuVisible" mode="side">
        <optsol-ngx-side-menu *ngIf="data" [data]="data" [compactView]="true" [collapsedOnStartup]="true">
            <img poweredByImage [src]="'assets/images/optsol.png'" width="30%" />
            <ng-container environment>V{{versionCode}}</ng-container>
        </optsol-ngx-side-menu>
    </mat-sidenav>
    <mat-sidenav-content class="os-sidenav-content os-pt1 os-pl1 os-pr1">
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>

<optsol-ngx-version-checker [interval]="interval" [endpoint]="versionCheckerUrl" [applicationCode]="applicationCode" [versionCode]="versionCode" (forceLogout)="logout()"></optsol-ngx-version-checker>
